import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import rupeeCoinAnimation from '../../assets/Rupee Coin.json';
import ScrollToTopButton from '../../components/ScrollToTopButton'
import './services.css'

  const services = [
  {
    title: 'Website Development',
    description: 'Static and dynamic websites, portfolio sites built to showcase your work beautifully.',
    icon: '💻'
  },
  {
    title: 'Website Design',
    description: 'Custom UI/UX designs focused on user engagement and brand identity.',
    icon: '🎨'
  },
  {
    title: 'Data Dashboard',
    description: 'Creating a user-friendly admin panel to manage, update, and control data visibility with ease.',
    icon: '🗄️'
  },
  {
    title: 'SEO Optimization',
    description: 'Improve your search engine ranking and increase organic traffic.',
    icon: '📈'
  },
  {
    title: 'Domain & Hosting',
    description: 'Reliable domain registration and fast hosting solutions.',
    icon: '🌐'
  },
  {
    title: 'Website Maintenance',
    description: 'Regular updates, website monitoring and performance optimizations.',
    icon: '🔧'
  },
  {
    title: 'Brand Design',
    description: 'Creative branding assets including logos and promotional posters.',
    icon: '✨'
  },
  {
    title: 'Content Writing',
    description: 'Engaging and SEO-friendly website content tailored to your audience.',
    icon: '✍️'
  }
]

const pricingPlans = [
  {
    title: 'Starter',
    description: 'Smart choice for small businesses and personal portfolios',
    features: [
      'Single Page Application',
      'Mobile Responsive Design',
      'Seperate Contact Page',
      'Website Content writing',
      'Page transition effects',
      'Email confuguration & integration',
      'Whatsapp integration',
      'Google map integration',
      'Social Media Links',
      'Hosting & Domain Setup',
      'Basic SEO Setup',
      'Affordable yearly renewal',
      '1 Month Support',
    ],
    popular: false,
    icon: '🚀',
    color: 'from-blue-500 to-cyan-500'
  },
  {
    title: 'E-commerce',
    description: 'Complete online store solution for your business',
    features: [
      'Upto 5 pages',
      'Product Catalog Management',
      'Inventory Management',
      'Order Management System',
      'Payment Gateway Integration',
      'Secured login & payments',
      'SSL Certificate',
      'Mobile Responsive Design',
      'Email Configuration & Integration',
      'Whatsapp Integration',
      'Google Map Integration',
      'Social Media Links',
      'Hosting & Domain Setup',
      'Basic SEO & Analytics Setup',
      'Affordable yearly renewal',
      '2 Months Support',
    ],
    popular: false,
    icon: '🛒',
    color: 'from-emerald-500 to-teal-500'
  },
  {
    title: 'Advanced',
    description: 'Built for brands that want more pages, more features, more impact',
    features: [
      'Upto 5 pages',
      'Custom website design',
      'Website content writing',
      'Limited page animations',
      'Static brochure download',
      'Mobile Responsive Design',
      'Performance Optimization',
      'Email Configuration & Integration',
      'Google Calendar Integration',
      'Whatsapp Integration',
      'Google Map Integration',
      'Social Media Links',
      'Hosting & Domain Setup',
      'Advanced SEO Setup',
      'Affordable yearly renewal',
      '2 Months Priority Support',
    ],
    popular: true,
    icon: '💎',
    color: 'from-purple-500 to-pink-500'
  },
  {
    title: 'Premium',
    description: 'Full control with custom features, backend, and integrations',
    features: [
      'Unlimited pages',
      'Custom website design/development',
      'Custom admin portal features development',
      'Secured login for Admin portal',
      'Backend database integration',
      'Third party API integration',
      'User friendly content updates',
      'Dynamic images/contents uploads',
      'Dynamic brochure uploads/downloads',
      'Mobile Responsive Design',
      'Performance Optimization',
      'Email Configuration & Integration',
      'Google Calendar Integration',
      'Whatsapp Integration',
      'Google Map Integration',
      'Social Media Links',
      'Hosting & Domain (portal & website)',
      'Advanced SEO & Analytics',
      'Affordable yearly renewal',
      '3 Months Priority Support',
    ],
    popular: true,
    icon: '💎',
    color: 'from-purple-500 to-pink-500'
  },
  {
    title: 'Add-on Customizations',
    description: 'Additional features and customizations for existing websites',
    features: [
      'Custom Feature Development',
      'Photography for products/contents',
      'Logo Design',
      'Poster & flyer for promotion',
      'Design Modifications',
      'Performance Enhancements',
      'Automated content updates',
      'Website migration',
      'Security Upgrades',
      'Plugin Integration',
      'Ongoing Maintenance',
      'Technical Consultation',
    ],
    popular: false,
    icon: '⚡',
    color: 'from-orange-500 to-red-500'
  },
];


export default function Services() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [visibleIndexes, setVisibleIndexes] = useState([]);



 useEffect(() => {
  const handleScroll = () => {
    setScrolled(window.scrollY > 30);

    const scrollPos = window.scrollY + window.innerHeight;
    services.forEach((_, i) => {
      const element = document.getElementById(`service-card-${i}`);
      if (element) {
        const top = element.offsetTop;
        // More generous visibility detection
        if (scrollPos > top + 100) {
          setVisibleIndexes((prev) => (prev.includes(i) ? prev : [...prev, i]));
        }
      }
    });
  };

  // Make all services visible by default after a short delay
  const timer = setTimeout(() => {
    setVisibleIndexes(services.map((_, i) => i));
  }, 500);

  // Also run scroll detection
  setTimeout(() => {
    handleScroll();
  }, 100);

  window.addEventListener('scroll', handleScroll);
  return () => {
    window.removeEventListener('scroll', handleScroll);
    clearTimeout(timer);
  };
}, []);

  return (
    <div>
      {/* semicircle element */}
      <div className="relative overflow-hidden">
        <div className={`service-semicircle ${scrolled ? 'scrolled' : ''}`}></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <h1 className="typewriter headline">Building sleek, modern websites...</h1>
          <p className="typewriter subheadline mt-4">Tailored for growth—whether you teach or innovate.</p>
        </div>
      </div>

      {/* rest of the service content */}
      <section className="px-6 pt-20 max-w-6xl mx-auto">
        <h2 className="services-title text-3xl font-semibold text-center mb-12">Services Tailored For You</h2>
        <div className="services-container">
          <div className="services-grid">
            {services.map(({ title, description, icon }, i) => (
              <div
                key={i}
                id={`service-card-${i}`}
                className="service-card"
                style={{
                  opacity: visibleIndexes.includes(i) ? 1 : 0,
                  transform: visibleIndexes.includes(i) ? 'translateY(0)' : 'translateY(30px)',
                  transition: `all 0.6s ease ${i * 0.1}s`
                }}
              >
                <div className="service-icon">
                  {icon}
                </div>
                <h3 className="service-card-title">{title}</h3>
                <p className="service-card-desc">{description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/*Pricing */}
      <section className="pricing-section max-w-7xl">
        <div className="pricing-background">
          <div className="pricing-gradient"></div>
        </div>
        <div className="pricing-content">
          <h2 className="pricing-title">Choose Your Perfect Package</h2>
          <p className="pricing-subtitle">Professional web solutions tailored to your business needs</p>
          
          {/* Stylish Price Banner */}
          <div className="price-banner">
            <div className="price-banner-content">
              <div className="price-banner-coin">
                <Lottie 
                  animationData={rupeeCoinAnimation} 
                  className="rupee-coin-animation"
                  loop={true}
                  autoplay={true}
                  rendererSettings={{
                    preserveAspectRatio: 'xMidYMid slice',
                    clearCanvas: false,
                    progressiveLoad: false,
                    hideOnTransparent: true
                  }}
                />
              </div>
              <div className="price-banner-text-section">
                <span className="price-banner-text">Packages starting from</span>
                <span className="price-banner-amount">₹10,000/-</span>
              </div>
              <div className="price-banner-decoration"></div>
            </div>
          </div>
          
          {/* Small CTA Section */}
          <div className="mini-cta-section">
            <div className="mini-cta-content">
              <div className="mini-cta-text">
                <span className="mini-cta-main">Got a different budget?</span>
                <span className="mini-cta-sub">Let's make it work! 💡</span>
              </div>
              <button 
                className="mini-cta-button"
                onClick={() => window.open('https://wa.me/918056064224?text=Hi! I have a specific budget in mind. Can we discuss a custom solution?', '_blank')}
              >
                <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                </svg>
                <span>Let's Talk</span>
              </button>
            </div>
          </div>
          
          <div className="accordion-container">
            {pricingPlans.map(({ title, description, features, popular, icon, color }, i) => (
              <div
                key={i}
                className={`accordion-panel ${popular ? 'popular' : ''}`}
                style={{
                  '--panel-delay': `${i * 0.1}s`,
                  '--panel-index': i
                }}
                onClick={() => {
                  const panel = document.querySelectorAll('.accordion-panel')[i];
                  const isActive = panel.classList.contains('active');
                  
                  // Close all panels
                  document.querySelectorAll('.accordion-panel').forEach(p => {
                    p.classList.remove('active');
                  });
                  
                  // Open clicked panel if it wasn't active
                  if (!isActive) {
                    panel.classList.add('active');
                  }
                }}
              >
                <div className="panel-header">
                  <div className="panel-left">
                    <div className={`panel-icon bg-gradient-to-r ${color}`}>
                      {icon}
                    </div>
                    <div className="panel-info">
                      <h4 className="panel-title">{title}</h4>
                      <p className="panel-description">{description}</p>
                    </div>
                  </div>
                  <div className="panel-right">
                    {popular && <div className="popular-badge">⭐ Popular</div>}
                    <div className="panel-toggle">
                      <svg className="toggle-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <polyline points="6,9 12,15 18,9"></polyline>
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="panel-content">
                  <div className="features-grid">
                    <div className="features-list">
                      <h5>What's Included:</h5>
                      <ul>
                        {features.map((feature, j) => (
                          <li key={j}>
                            <span className="feature-check">✓</span>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="panel-actions">
                      <button 
                        className={`action-button primary bg-gradient-to-r ${color}`}
                        onClick={() => navigate('/contact')}
                      >
                        Get Quote
                      </button>
                      {/* <button className="action-button secondary">
                        Learn More
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  )
}
